import React from 'react';
import TimePicker from 'material-ui/TimePicker';

export default props => (
  <TimePicker
    {...props.inputProps}
    {...props.input}
    onChange={(event, value) => {
      props.input.onChange(value);

      if (props.inputProps.onChange) {
        props.inputProps.onChange(value);
      }
    }}
  />
);



// WEBPACK FOOTER //
// src/modules/forms/components/TimePicker.js